import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectWebsiteTheme } from '../../../store/slices/website';

import CLButton from '../../../components/CLButton';
import CLCurrency from '../../../components/CLCurrency';

import NoPhoto from '../../../assets/images/no-photo.svg';

import {
  Container,
  Photo,
  Description,
  Title,
} from './styled';

const Item = ({ item, itemSize, onReserve }) => {
  const { t } = useTranslation();

  const { colors } = useSelector(selectWebsiteTheme);

  const renderPrice = (item) => {
    if (!item.has_fee) {
      return t('free', 'Free');
    }

    return <CLCurrency value={item.fee_amount} currency="USD" />;
  };

  return (
    <Container
      itemSize={itemSize}
      bgColor={colors[2].color}
    >
      <Photo
        placeholder={item.files[0]?.medium_url ? 0 : 1}
        image={item.files[0]?.medium_url || NoPhoto}
      />
      <Description>
        <Title>{item.name}</Title>
        <CLButton style={{ width: '100%' }} primary onClick={() => onReserve(item)}>
          {t('reserve', 'Reserve')}
          &nbsp;
          (
          {renderPrice(item)}
          )
        </CLButton>
      </Description>
    </Container>
  );
};

Item.propTypes = {
  item: PropTypes.object.isRequired,
  itemSize: PropTypes.shape({
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
  }).isRequired,
  onReserve: PropTypes.func.isRequired,
};

export default Item;
